module.exports = __webpack_public_path__ + "toBride1-we-p-g.9e2cb267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-p-g.jpg
// module id = iaEx
// module chunks = 0